import * as React from "react";
import { Idevice } from "./../../../types/device";
import DeviceContext from "./../../../service/indentifyDevice";
import FtContainerDesk from "../ftContainer/ftContainerDesk";
import FtContainerTab from "../ftContainer/ftContainerTab";
import FtContainerMob from "../ftContainer/ftContainerMob";
import FtHistoryWrap from "./ftHistory/ftHistoryWrap";
import { RouteChildrenProps } from "react-router-dom";
import DatePickerInt from "../../orderBook/obContainer/obDatePickerInt";

export interface IFtHistoryContProps {}

const FtHistoryCont: React.FC<IFtHistoryContProps & RouteChildrenProps> = (props) => {
	const deviceState: Idevice = DeviceContext();
	const getDates = (frmDt: Date, toDate: Date) => {
		childRef.current?.getDates(frmDt, toDate);
	};
	const childRef = React.useRef<{ getDates: (frmDt: Date, toDate: Date) => void }>(null);
	const inst = <FtHistoryWrap match={props.match} ref={childRef} />;

	const DateComp = <DatePickerInt plusDays={30} sendDates={getDates} toDateCt={0} />;
	return (
		<section className="ftSection">
			<section className="historyCont">
				{deviceState.isDesktop ? (
					<FtContainerDesk instComp={inst} />
				) : deviceState.isTablet ? (
					<FtContainerTab instComp={inst} />
				) : (
					<FtContainerMob instComp={inst} dateComp={DateComp} />
				)}
			</section>
		</section>
	);
};

export default FtHistoryCont;
